/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Check_All_InInputs */



/**
* | output |
* | --- |
* | "Check All In" |
*
* @param {Overview_Check_All_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_check_all_in = /** @type {((inputs?: Overview_Check_All_InInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Check_All_InInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Check-in a todos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Check-in Geral")
	if (locale === "it") return /** @type {LocalizedString} */ ("Check In Tutti")
	return /** @type {LocalizedString} */ ("Check All In")
});